import React, { useCallback, useEffect, useRef, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Button, Select, TextField } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import debounce from 'lodash/debounce';
import { searcher } from '../../helpers/searcher';
import CityIcon from '../../img/megurimIcon.svg';

const Item = styled(Box)(({ theme }) => ({
	...theme.typography.body2,
	padding: theme.spacing(1),
	// textAlign: 'center',
	color: theme.palette.text.secondary,
}));
const AutoCompleteListItem = styled(Box)(({ theme }) => ({
	paddingLeft: '20px',
	'&:hover': {
		background: 'blue',
	},
}));
export default function SearchBox(props: any) {
	const { sxAutoComplete, sx, onFocus, onBlur, onClick, onChange } = props;
	const [options, setOptions] = useState([]);
	const [searchInput, setSearchInput] = useState('');
	const lastValueSearchedRef = useRef('');
	const lastSearchedPointRef = useRef<any>({});

	const getOptionsDelayed = useCallback(
		debounce((text: string, callback: any) => {
			setOptions([]);
			if (text.length > 2) {
				if (
					text !== lastValueSearchedRef.current && // dont send api request if current value aquals previous value
					text !== lastSearchedPointRef?.current?.formatted // dont send api request if current value aquals the
					// last given object.formatted. (in the onClick of the autocomplete input event it will fly to the last point )
				) {
					lastValueSearchedRef.current = text;
					searcher(text).then(callback);
				}
			}
		}, 250),
		[]
	);

	useEffect(() => {
		getOptionsDelayed(searchInput, (filteredOptions: any) => {
			// console.log(filteredOptions);
			setOptions(filteredOptions);
			// setLastValueSearched(searchInput);
		});
	}, [searchInput, getOptionsDelayed]);
	return (
		<Autocomplete
			autoHighlight
			renderOption={(prop: any, option: any) => {
				console.log(option);
				// console.log(props);

				return (
					<AutoCompleteListItem
						component="li"
						key={option.place_id}
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...prop}
						// onClick={() => {
						// 	console.log(option);
						// }}
					>
						<Stack spacing={2} direction="row">
							<Box pt={1} pb={1}>
								<Item>
									<img src={CityIcon} alt="CityIcon" />
								</Item>
							</Box>
							<Item>
								<Box m={0}>
									<Typography variant="body1" gutterBottom>
										{option.formatted}
									</Typography>
								</Box>
								<Box m={0}>
									<Typography variant="body2" gutterBottom>
										{option.result_type}
									</Typography>
								</Box>
							</Item>
						</Stack>
					</AutoCompleteListItem>
				);
			}}
			filterOptions={(options2: any) => options2}
			openOnFocus={false}
			// popupIcon={<SearchIcon />}
			// clearIcon={<MegurimIcon />}
			forcePopupIcon={false}
			// disablePortal
			id="combo-box-demo"
			options={options}
			getOptionLabel={(option: any) => option.formatted}
			sx={sxAutoComplete}
			size="small"
			// inputValue={searchInput}
			onInputChange={(e, newInputValue) => {
				// console.log('#' + newInputValue);
				// console.log(e.type);
				//	if (e.type === 'change') {
				console.log(encodeURIComponent(newInputValue));
				setSearchInput(encodeURIComponent(newInputValue));
				//	}
			}}
			// PopperComponent={CustomPopper} //required (as far as I can tell) in order to target popper elements for custom styling
			loading
			// onMouseEnter={() => console.log(searchInput.length)}
			renderInput={(params) => (
				<div>
					<Paper component="form" sx={sx}>
						<TextField
							value={searchInput}
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...params}
							placeholder="חיפוש..."
							onMouseDownCapture={(e) => e.stopPropagation()} // prevent the list from showing up when focusing the search
							onFocus={onFocus}
							onBlur={onBlur}
						/>
						{/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}

						<IconButton
							type="button"
							sx={{ p: '10px' }}
							aria-label="search"
							onClick={onClick}
						>
							<SearchIcon />
						</IconButton>
					</Paper>
				</div>
			)}
			onChange={onChange}
		/>
	);
}
